
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../base-error";

@Component({
  selector: "file-upload-determinant",
  templateUrl: "./file-upload-determinant.component.html",
  styles: [],
  providers: [
    ToastrService,
  ],
})
export class FileUploadDeterminantComponent extends BaseError implements OnInit, OnChanges {
  @Input() public serviceId: string;
  @Input() public fileUploadEventName: string = "change";
  @Input() public fileUploadKey: string;
  @Output() public fileUploadEventNameResponse = new EventEmitter();
  @Output() public fileUploadKeyResponse = new EventEmitter();

  public fileUploadEvents: any[] = [
    { key: "change", name: "Change (File Uploaded)" }
  ];

  constructor(
    public toastr: ToastrService,
  ) {
    super(toastr);
  }

  public ngOnInit() {
    // File upload field is now selected in parent component's "Select field"
  }

  public fileUploadKeyChanged(newFileUploadKey: string) {
    this.fileUploadKey = newFileUploadKey;
    this.fileUploadKeyResponse.emit(newFileUploadKey);
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    console.log("---- CHANGES", changes);
    if (changes.fileUploadEventName?.currentValue) {
      this.fileUploadEventName = changes.fileUploadEventName.currentValue;
    }
    if (changes.fileUploadKey?.currentValue) {
      this.fileUploadKey = changes.fileUploadKey.currentValue;
    }
  }

  public fileUploadEventNameChanged() {
    this.fileUploadEventNameResponse.emit(this.fileUploadEventName);
  }
}
